import { useState, useCallback } from 'react';

type MutationState<TData> = {
  data: TData | null;
  loading: boolean;
  error: Error | null;
};

export function useRestMutation<TData, TVariables = unknown>(
  mutationFn: (variables: TVariables) => Promise<TData>
) {
  const [state, setState] = useState<MutationState<TData>>({
    data: null,
    loading: false,
    error: null,
  });

  const trigger = useCallback(
    async (variables: TVariables): Promise<TData | undefined> => {
      setState({ data: null, loading: true, error: null });
      try {
        const result = await mutationFn(variables);
        setState({ data: result, loading: false, error: null });
        return result;
      } catch (err) {
        const error = err instanceof Error ? err : new Error(String(err));
        setState({ data: null, loading: false, error });
        return undefined;
      }
    },
    [mutationFn]
  );

  return [trigger, state] as const;
}
